// extracted by css-extract-rspack-plugin
export default {"primary":"ZiwN5HQ0Md4_9S2G","secondary":"kUDw8kddYGcttx4h"};